import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { LOCAL_STORAGE_getToken, LOCAL_STORAGE_removeToken } from '../../localStorage/token.localStorage'
import jwtDecode from 'jwt-decode'
import { USER_DATA } from '../../types/userData.interface'

type AuthContextType = {
    token: string | null
    user: USER_DATA | null
    setUser: React.Dispatch<React.SetStateAction<USER_DATA | null>>
    setToken: React.Dispatch<React.SetStateAction<string | null>>
    isLoggedIn: boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider')
    }
    return context
}

const checkTokenValidity = (token: string): boolean => {
    if (!token) return false
    const decodedToken: any = jwtDecode(token)
    const currentTime = Date.now() / 1000

    // log out user if the token is one day away from expiring
    // TEMPORARY SOLUTION since we don't have refresh token yet + the token is valid for 84 days
    const currentTimePlusOneDay = currentTime + 86400

    return decodedToken.exp > currentTimePlusOneDay
}

export const AuthProvider: React.FC = ({ children }) => {
    const [token, setToken] = useState<string | null>(() => {
        const storedToken = LOCAL_STORAGE_getToken()
        if (!storedToken) return storedToken
        if (checkTokenValidity(storedToken)) return storedToken

        LOCAL_STORAGE_removeToken()
        return null
    })
    const [user, setUser] = useState<any>(null)
    const isLoggedIn = !!token

    return (
        <AuthContext.Provider value={{ user, setUser, token, setToken, isLoggedIn }}>{children}</AuthContext.Provider>
    )
}
